export const helpData = [
    {
        title:"From your dashboard :",
        desc1:"1.Hover over the prototype",
        desc2:"2. From here, you should be able to see the option to 'Play' your prototype below the prototype's icon"
    },
    {
        title:"Within your project",
        desc1:"1.Select the project",
        desc2:"2. From here, you should be able to see the option to 'Play' your prototype below the prototype's icon",
        desc3:"3. You can also hover over a screen to start playback from a specific screen ✨"
    },
    {
        title:"Whilst adding hotspots to your prototype",
        desc1:"1. Select the project",
        desc2:"2. Hover over the prototype and select 'Prototype'",
        desc3:"3. Click 'Play' on the top right-hand corner"
    },
    {
        desc1:"You’ll receive an email confirmation that your free trial has been canceled. If you signed up with a credit card, your plan will be downgraded to Hostdesign Basic at the end of your trial period. If you signed up with PayPal, your trial will end and your plan will be downgraded immediately. When you cancel a subscription, the cancellation will take effect at the end of your current billing cycle. To check or change your billing cycle, visit the billing page in your account settings."
    },
    {
        title:"Playing a prototype on Tablet and Mobile Browsers",
        desc1:"The easiest way to play a prototype from a mobile device is by using the Share URL. However, you can also log in to Marvel in your browser and follow the same steps above."
    },
    {
        title:"Playing your prototype in your browser",
        desc1:"1. Open Project Share URL in your browser",
        desc2:"2. Play through prototype as normal"
    },
    {
        title:"Whilst adding hotspots to your prototype",
        desc1:"1. Select the project",
        desc2:"2. Hover over the prototype and select 'Prototype'",
        desc3:"3. Click 'Play' on the top right-hand corner"
    },
    {
        desc1:"You’ll receive an email confirmation that your free trial has been canceled. If you signed up with a credit card, your plan will be downgraded to Hostdesign Basic at the end of your trial period. If you signed up with PayPal, your trial will end and your plan will be downgraded immediately. When you cancel a subscription, the cancellation will take effect at the end of your current billing cycle. To check or change your billing cycle, visit the billing page in your account settings."
    },
    {
       title:"Within your project",
       desc1:"1. Select the project",
       desc2:"2. Click 'Play' on the top right-hand corner",
       desc3:"3. You can also hover over a screen to start playback from a specific screen ✨"
    }
]

export const relatedData= [
    {
        desc1:"• How to link screens with hotspots"
    },
    {
        desc1:"• How to make a copy of your designs"
    },
    {
        desc1:"• How to play your prototype in desktop, tablet and mobile browsers"
    },
    {
        desc1:"• How do I duplicate a hotspot?"
    },
    {
        desc1:"• How do I replace or update a screen in my prototype?"
    },
    {
        desc1:"• How to use transitions"
    },
    {
        desc1:"• How to add designs to your prototype"
    },
    {
        desc1:"• How to wireframe and design in HostDesign"
    },
    {
        desc1:"• How to make a copy of your designs"
    },
    {
        desc1:"• How to delete a section"
    },
    {
        desc1:"• How do I duplicate a hotspot?"
    }, {
        desc1:"• How to manually enter or view the size and X/Y coordinates of your hotspot is that awesome "
    },
    {
        desc1:"• How to rename a section"
    },
    {
        desc1:"• How to collapse a section"
    },
    {
        desc1:"• How to move a section to another position"
    }
]